/* Pellmaro section behavior: restrained motion, lazy media and reveal effects. */
(function () {
  var $$ = function (selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setVideoState(container, playing) {
    var button = container.querySelector('[data-pm-video-toggle]');
    if (!button) return;
    button.classList.toggle('is-playing', playing);
    button.setAttribute('aria-label', playing ? 'Mettre la vidéo en pause' : 'Lire la vidéo');
    var icon = button.querySelector('span');
    if (icon) icon.textContent = playing ? '❚❚' : '▶';
  }

  /* Carte atelier : séquences muettes lancées à l'entrée du viewport,
     en pause à la sortie ; jamais lancées si l'utilisateur réduit les animations. */
  var atelier = document.querySelector('[data-pm-atelier]');
  if (atelier) {
    var atelierVideos = $$('video', atelier);
    if (reduceMotion || !('IntersectionObserver' in window)) {
      atelierVideos.forEach(function (video) { video.preload = 'metadata'; });
    } else {
      var atelierObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          atelierVideos.forEach(function (video) {
            if (entry.isIntersecting) {
              video.preload = 'auto';
              var playing = video.play();
              if (playing) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        });
      }, { rootMargin: '160px 0px', threshold: 0.15 });
      atelierObserver.observe(atelier);
    }
  }

  /* Reel videos autoplay muted when visible and loop continuously. */
  var videoContainers = $$('.pm-reel__item');
  videoContainers.forEach(function (container) {
    var video = container.querySelector('video');
    if (!video) return;
    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';
  });
  var reelSection = document.querySelector('.pm-reel');
  if ('IntersectionObserver' in window && reelSection && videoContainers.length) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        videoContainers.forEach(function (container) {
          var video = container.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            var playPromise = video.play();
            if (playPromise) playPromise.then(function () { setVideoState(container, true); }).catch(function () { setVideoState(container, false); });
          } else {
            video.pause();
            setVideoState(container, false);
          }
        });
      });
    }, { rootMargin: '160px 0px', threshold: 0.1 });
    videoObserver.observe(reelSection);
  } else {
    videoContainers.forEach(function (container) {
      var video = container.querySelector('video');
      if (!video) return;
      var playPromise = video.play();
      if (playPromise) playPromise.then(function () { setVideoState(container, true); }).catch(function () { setVideoState(container, false); });
    });
  }

  $$('[data-pm-video-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var container = button.closest('.pm-reel__item');
      var video = container && container.querySelector('video');
      if (!video) return;
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise) playPromise.then(function () { setVideoState(container, true); }).catch(function () {});
      } else {
        video.pause();
        setVideoState(container, false);
      }
    });
  });

  /* Scroll reveal stays subtle and is completely disabled for reduced motion. */
  var revealSelectors = [
    '.pm-section__head', '.pm-card', '.pm-category-tile', '.pm-split__media', '.pm-split__text',
    '.pm-story__text', '.pm-story__media', '.pm-steps li', '.pm-review', '.pm-guarantees>div', '.pm-insta__cell'
  ];
  revealSelectors.forEach(function (selector) {
    $$(selector).forEach(function (element) { element.classList.add('pm-reveal'); });
  });

  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    $$('.pm-reveal').forEach(function (element, index) {
      element.style.transitionDelay = (index % 4) * 60 + 'ms';
      revealObserver.observe(element);
    });
  } else {
    $$('.pm-reveal').forEach(function (element) { element.classList.add('in'); });
  }

  /* Carrousel d'avis : boutons précédent/suivant (pas de lecture automatique). */
  $$('[data-pm-reviews]').forEach(function (root) {
    var track = root.querySelector('[data-pm-reviews-track]');
    if (!track) return;
    var step = function () {
      var item = track.querySelector('.pm-reviews__item');
      return item ? item.getBoundingClientRect().width + 12 : 320;
    };
    var prev = root.querySelector('[data-pm-reviews-prev]');
    var next = root.querySelector('[data-pm-reviews-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
  });

  /* Le héros desktop est plafonné à l'écran restant sous l'annonce +
     l'en-tête : la hauteur réelle est mesurée et posée en variable CSS
     (repli CSS : 96px) pour que rien d'important ne passe sous le pli. */
  if (document.querySelector('.pm-hero')) {
    var setHeroOffset = function () {
      var announce = document.querySelector('.pm-announce');
      var headerBar = document.querySelector('.pm-header');
      var offset = (announce ? announce.offsetHeight : 0) + (headerBar ? headerBar.offsetHeight : 0);
      if (offset > 0) document.documentElement.style.setProperty('--pm-hero-offset', offset + 'px');
    };
    setHeroOffset();
    window.addEventListener('resize', setHeroOffset);
    window.addEventListener('load', setHeroOffset);
  }

  /* Keep the mobile campaign CTAs unobstructed; surface WhatsApp after the hero. */
  var whatsappFloat = document.querySelector('.pm-wa-float');
  if (whatsappFloat && window.matchMedia('(max-width: 749px)').matches) {
    var updateWhatsappFloat = function () {
      var ready = window.scrollY > Math.min(window.innerHeight * 0.72, 560);
      whatsappFloat.classList.toggle('is-ready', ready);
      whatsappFloat.setAttribute('aria-hidden', ready ? 'false' : 'true');
      whatsappFloat.tabIndex = ready ? 0 : -1;
    };
    updateWhatsappFloat();
    window.addEventListener('scroll', updateWhatsappFloat, { passive: true });
  }
})();
